module.exports = __webpack_public_path__ + "img/img0.396cf504.jpg";